import React, {useEffect, useRef, useState} from 'react';
import styled from "styled-components";
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import CameraLive from "../camera/CameraLive";
import Canvas from "../canvas/CanvasLines";
import {colors} from "../../maps/colors";

const WrapperSvgStyled = styled.div`

`;

const WrapperStyled = styled.div`

`;

const PoseDetectionTest = ({camera, onClose, poseDetection}) => {
    const stage = useRef(null);

    const [height, s_height] = useState(0);

    useEffect(() => {
        if (stage.current && stage.current.offsetWidth) {
            s_height(stage.current.offsetHeight);
        }
    }, [stage.current]);

    const {streamFullRtspUrl, pt, z, rotate} = camera;

    const lines = [];
    const names = [];

    // from shoudler - elbow  - #019811
    // from elbow - wrist  - #34e500

    // from hip - knee  - #fbaa01
    // from knee - ankle  - #fdd546

    // console.log("poseDetection",poseDetection);

    const width = 1200;

    const setXY = (startList, endList = [], color = '#fff') => {
        return {
            startX: width * startList[0] / 100,
            startY: height * startList[1] / 100,
            endX: width * endList[0] / 100,
            endY: height * endList[1] / 100,
            strokeStyle: color,
            lineWidth: 2
        };
    };

    poseDetection?.pose?.forEach(poseData => {
        const xMax = poseData.boundingBoxPr.xMax;
        const xMin = poseData.boundingBoxPr.xMin;
        const yMax = poseData.boundingBoxPr.yMax;
        const yMin = poseData.boundingBoxPr.yMin;


        const left_shoulder = poseData.left_shoulder;
        const right_shoulder = poseData.right_shoulder;
        const left_elbow = poseData.left_elbow;
        const right_elbow = poseData.right_elbow;
        const left_wrist = poseData.left_wrist;
        const right_wrist = poseData.right_wrist;


        const left_hip = poseData.left_hip;
        const right_hip = poseData.right_hip;
        const left_knee = poseData.left_knee;
        const right_knee = poseData.right_knee;
        const left_ankle = poseData.left_ankle;
        const right_ankle = poseData.right_ankle;

        // box
        if (xMax && xMin && yMax && yMin) {
            // lines.push({
            //     startX: width * xMin / 100,
            //     startY: height * yMin / 100,
            //     endX: width * xMax / 100,
            //     endY: height * yMax / 100,
            //     strokeStyle: '#fdd546',
            //     lineWidth: 2
            // });
        }

        // upper
        if (left_shoulder && left_elbow) {
            lines.push(setXY(left_shoulder, left_elbow, colors.BLUE));
        }
        if (right_shoulder && right_elbow) {
            lines.push(setXY(right_shoulder, right_elbow, colors.BLUE));
        }
        if (left_elbow && left_wrist) {
            lines.push(setXY(left_elbow, left_wrist, colors.BLUE));
        }
        if (right_elbow && right_wrist) {
            lines.push(setXY(right_elbow, right_wrist, colors.BLUE));
        }
        if (left_shoulder && right_shoulder) {
            lines.push(setXY(left_shoulder, right_shoulder, colors.BLUE));
        }

        // lower
        if (left_hip && left_knee) {
            lines.push(setXY(left_hip, left_knee, colors.ORANGE));
        }
        if (right_hip && right_knee) {
            lines.push(setXY(right_hip, right_knee, colors.ORANGE));
        }
        if (left_knee && left_ankle) {
            lines.push(setXY(left_knee, left_ankle, colors.ORANGE));
        }
        if (right_knee && right_ankle) {
            lines.push(setXY(right_knee, right_ankle, colors.ORANGE));
        }
        if (left_hip && right_hip) {
            lines.push(setXY(left_hip, right_hip, colors.ORANGE));
        }

        // body
        if (left_hip && left_shoulder) {
            lines.push(setXY(left_hip, left_shoulder, colors.PINK));
        }
        if (right_hip && right_shoulder) {
            lines.push(setXY(right_hip, right_shoulder, colors.PINK));
        }

        const name = poseData.name;
        if (name) {
            const noseData = setXY(poseData.nose);

            names.push({
                name: name,
                x: noseData.startX,
                y: noseData.startY,
                trackId: poseData.trackId
            });
        }
    });

    return (
        <Dialog
            open={true}
            onClose={onClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            fullScreen={true}>

            <DialogTitle id="alert-dialog-title">
                Test Post Detection
            </DialogTitle>
            <DialogContent>
                <WrapperStyled style={{height: height, width: width}}>
                    <CameraLive
                        disableControls={true} pt={pt} z={z}
                        camera={camera}
                        rotate={rotate}
                        rtspUrl={streamFullRtspUrl}
                        resolution={`480x270`}>
                        <div
                            ref={stage}
                            style={{
                                cursor: 'pointer',
                                width: '100%',
                                height: '100%',
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                background: 'none'
                            }}>
                            <WrapperSvgStyled>
                                <Canvas
                                    height={height}
                                    width={width}
                                    background={"rgba(000,000,000, 0.0)"}
                                    lines={lines}
                                    names={names}
                                />
                            </WrapperSvgStyled>
                        </div>
                        )
                    </CameraLive>
                </WrapperStyled>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Close</Button>
            </DialogActions>
        </Dialog>
    );
};

export default PoseDetectionTest;